



























































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheAddonsFields',
    components: {
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            variation: {},
            price: { disabled: false, value: '' },
            priceVAT: { disabled: false, value: '' },
        };
    },
    watch: {
        'variation.price'(value) {
            if (value !== '') {
                this.priceVAT.disabled = true;
                this.priceVAT.value = String((Number(this.variation.price) * 1.20).toFixed(2));
            } else {
                this.priceVAT.disabled = false;
                this.priceVAT.value = '';
            }
        },
        'variation.priceVAT'(value) {
            if (value !== '') {
                this.price.disabled = true;
                this.price.value = String((Number(this.variation.priceVAT) / 1.20).toFixed(2));
            } else {
                this.price.disabled = false;
                this.price.value = '';
            }
        },
    },
    methods: {
        submitVariation() {
            this.$emit('addVariation', {
                weight: this.variation.weight,
                weight_unit: this.variation.weight_unit,
                price: this.variation.price === '' ? this.price.value : this.variation.price,
                price_with_vat: this.variation.priceVAT === '' ? this.priceVAT.value : this.variation.priceVAT,
                is_active: this.variation.is_active,
            });
        },
    },
    created() {
        this.variation = {
            weight: '',
            weight_unit: '',
            price: '',
            priceVAT: '',
            is_active: '',
        };
    },
};
